import { Form, Formik } from "formik";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from "../../../components/form-footer";
import { selectActiveFormWitnessDefendantStatementDetails, selectActiveFormWitnessDefendantStatementDefendantDetails, updateWitnessDefendantStatementDefendantDetails } from "../../../reducers/active-form-slice";
import WitnessDefendantStatementDefendantDetailsSchema from "../../../validation-schemas/witness-defendant-statement-defendant-details";
import IntakeWitnessDefendantStatementDefendantDetailsFields from "../../../components/intake/witness-defendant-statement/defendant-info-fields";
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';


const IntakeWitnessDefendantStatementDefendantInfo = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const witnessDefendantStatementDetails = useSelector(selectActiveFormWitnessDefendantStatementDetails);
    const witnessDefendantStatementDefendantDetails = useSelector(selectActiveFormWitnessDefendantStatementDefendantDetails);
    const hasValues = hasNonBlankValues(witnessDefendantStatementDefendantDetails);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/witness-defendant-statement/details");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateWitnessDefendantStatementDefendantDetails(values));

        switch (witnessDefendantStatementDetails.statementType) {
            case "Both":
                navigate("/intake/witness-defendant-statement/witness-info");
                break;
            default:
                navigate("/intake/witness-defendant-statement/info");
                break;
        }
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateWitnessDefendantStatementDefendantDetails(values));
    };


    /**
     * setup the initial values
     */
    const defendantsInitialValue = {
        firstName: '',
        lastName: '',
        phones: [],
        address1: '',
        address2: '',
        city: '',
        stateProvince: '',
        zip: '',
        county: '',
        directionOfTravel: '',
        streetOfTravel: '',
        defendantVehicleDescription: '',
    };

    const initialValues = {
        defendants: [
            defendantsInitialValue
        ],
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? witnessDefendantStatementDefendantDetails : initialValues}
                validationSchema={WitnessDefendantStatementDefendantDetailsSchema.fields.witnessDefendantStatementDefendantDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Witness OR Defendant Statement Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeWitnessDefendantStatementDefendantDetailsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                            initialValues={defendantsInitialValue}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`40`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeWitnessDefendantStatementDefendantInfo;